"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteBlockSummary = void 0;
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var TokenRenderer_1 = __importDefault(require("@CommonFrontend/ContentTokens/TokenRenderer"));
var Recurrence_1 = require("@CommonFrontendBackend/QuoteV2/Recurrence");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var QuoteSummaryContextProvider_1 = require("./QuoteSummaryContextProvider");
var styles = __importStar(require("./QuoteSummaryWidget.css"));
var Utils_1 = require("./Utils");
var DiscountableTotal_1 = require("./DiscountableTotal");
var SectionComponents_1 = require("./SectionComponents");
var classnames_1 = __importDefault(require("classnames"));
var QuoteBlockSummary = function (_a) {
    var _b, _c, _d;
    var quote = _a.quote;
    var settings = (0, QuoteSummaryContextProvider_1.useQuoteSummaryContext)().settings;
    var heading = (0, Utils_1.getFirstContentOfType)((_d = (_c = (_b = quote.contentAreas) === null || _b === void 0 ? void 0 : _b.header) === null || _c === void 0 ? void 0 : _c.tokens) !== null && _d !== void 0 ? _d : [], ["heading1", "heading2"]);
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: "quote-wrapper" },
        heading.length > 0 && (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.quoteHeading, "quote-heading"), dangerouslySetInnerHTML: {
                __html: (0, TokenRenderer_1.default)(heading),
            } })),
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "l", className: "quote-section-list" }, quote.sections
            .filter(function (section) {
            if (settings.showTextItems) {
                return section.items.length > 0;
            }
            else {
                return section.items.filter(function (item) { return item.type !== Types_1.QuoteItemType.Text; }).length > 0;
            }
        })
            .map(function (section, index) { return (react_1.default.createElement(SectionComponents_1.Section, { section: section, key: "section-".concat(index), labelSetId: quote.labelSetId })); })),
        quote.viewSettings.showQuoteTotals && (react_1.default.createElement(QuoteTotal, { total: quote.total, labelSetId: quote.labelSetId, discount: quote.discount, viewSettings: quote.viewSettings }))));
};
exports.QuoteBlockSummary = QuoteBlockSummary;
var QuoteTotal = function (_a) {
    var quoteTotal = _a.total, labelSetId = _a.labelSetId, discount = _a.discount, viewSettings = _a.viewSettings;
    var _b = (0, QuoteSummaryContextProvider_1.useQuoteSummaryContext)(), formatCurrency = _b.formatCurrency, getLabel = _b.getLabel;
    var totals = [];
    if ((0, Utils_1.hasRecurringTotals)(quoteTotal)) {
        Object.keys(quoteTotal.recurringTotals).forEach(function (key) {
            if ((0, Types_1.isRecurringFrequency)(key)) {
                var frequency = key;
                totals.push(__assign(__assign({}, quoteTotal.recurringTotals[frequency]), { frequency: frequency }));
            }
        });
    }
    return (react_1.default.createElement(kaleidoscope_1.Stack, { align: "end" },
        react_1.default.createElement("table", { className: (0, classnames_1.default)(styles.total, styles.quoteTotal) },
            react_1.default.createElement("tfoot", null,
                viewSettings.showTotalDiscount && (react_1.default.createElement("tr", { className: styles.totalLine },
                    react_1.default.createElement("td", { className: styles.totalCell() },
                        react_1.default.createElement("p", null,
                            getLabel(labelSetId, Types_1.QuoteLabel.Total),
                            " ",
                            getLabel(labelSetId, Types_1.QuoteLabel.Discount))),
                    react_1.default.createElement("td", { className: styles.totalCell({ align: "right" }) },
                        react_1.default.createElement("p", null, formatCurrency(quoteTotal.cumulativeDiscount * -1))))),
                !(0, lodash_1.isEmpty)(quoteTotal.oneOffTotals) && (react_1.default.createElement("tr", { className: styles.totalLine },
                    react_1.default.createElement("td", { className: styles.totalCell() },
                        react_1.default.createElement("p", null, (0, Utils_1.hasRecurringTotals)(quoteTotal)
                            ? "".concat(getLabel(labelSetId, Types_1.QuoteLabel.Total), " ").concat(getLabel(labelSetId, Types_1.QuoteLabel.OneOff))
                            : getLabel(labelSetId, Types_1.QuoteLabel.Total))),
                    react_1.default.createElement("td", { className: styles.totalCell({ align: "right" }) },
                        react_1.default.createElement(DiscountableTotal_1.DiscountableTotal, { preDiscount: quoteTotal.oneOffTotals.preDiscount, preTax: quoteTotal.oneOffTotals.preTax, labelSetId: labelSetId, discount: discount })))),
                (0, Utils_1.hasRecurringTotals)(quoteTotal) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("tr", { className: styles.totalLine },
                        react_1.default.createElement("td", { className: styles.totalCell() },
                            react_1.default.createElement("p", null,
                                getLabel(labelSetId, Types_1.QuoteLabel.Total),
                                " ",
                                getLabel(labelSetId, Types_1.QuoteLabel.Recurring))),
                        react_1.default.createElement("td", { className: styles.totalCell({ align: "right" }) }, (0, Utils_1.sortByDisplayOrder)(totals).map(function (total, index) {
                            var _a;
                            return (react_1.default.createElement(DiscountableTotal_1.DiscountableTotal, { key: "quote-recurring-total-".concat(index), preDiscount: (_a = total.preDiscount) !== null && _a !== void 0 ? _a : 0, preTax: total.preTax, labelSetId: labelSetId, discount: discount, frequencyLabel: getLabel(labelSetId, (0, Recurrence_1.mapRecurringFrequencyToPerLabel)(total.frequency)) }));
                        }))))),
                viewSettings.showExTax && (react_1.default.createElement("tr", { className: styles.totalLine },
                    react_1.default.createElement("td", { className: styles.totalCell() },
                        react_1.default.createElement("p", null,
                            getLabel(labelSetId, Types_1.QuoteLabel.Total),
                            " ",
                            getLabel(labelSetId, Types_1.QuoteLabel.DueTodayExcludingTax))),
                    react_1.default.createElement("td", { className: styles.totalCell({ align: "right" }) },
                        react_1.default.createElement("p", null, formatCurrency(quoteTotal.preTax))))),
                viewSettings.showTaxTotals &&
                    quoteTotal.totalTaxes &&
                    Object.keys(quoteTotal.totalTaxes).map(function (tax) { return (react_1.default.createElement("tr", { key: tax, className: styles.totalLine },
                        react_1.default.createElement("td", { className: styles.totalCell() },
                            react_1.default.createElement("p", null, tax)),
                        react_1.default.createElement("td", { className: styles.totalCell({ align: "right" }) },
                            react_1.default.createElement("p", null, formatCurrency(quoteTotal.totalTaxes[tax]))))); }),
                (0, Utils_1.hasRecurringTotals)(quoteTotal) && (react_1.default.createElement("tr", { className: styles.totalLine },
                    react_1.default.createElement("td", { className: styles.totalCell() },
                        react_1.default.createElement("p", null,
                            getLabel(labelSetId, Types_1.QuoteLabel.Total),
                            " ",
                            getLabel(labelSetId, Types_1.QuoteLabel.DueToday))),
                    react_1.default.createElement("td", { className: styles.totalCell({ align: "right" }) },
                        react_1.default.createElement("p", null, formatCurrency(quoteTotal.postTax)))))))));
};
